
const initCsrfToken = () => {
  let csrfToken = ''
  const tokenEl = document.querySelector('meta[name=csrf-token]')
  if (tokenEl !== null) {
    csrfToken = tokenEl.getAttribute('content') || ''
  }
  const getCsrfToken = () => {
    return {
      headerKey: 'X-CSRF-Token',
      csrfToken
    }
  }
  return getCsrfToken

}

const csrf = initCsrfToken()
export default csrf
